import { create } from "zustand";

type DataStore = {
	data: any;
	isLastPage: boolean;
	pageNo: number;
	option: any;
};

type DataStoreActions = {
	updateDataList: (data: any, pageNo: number, isLastPage: boolean, option: any) => void;
	resetDataList: () => void;
};

export const useFinishedTaskDataStore = create<DataStore & DataStoreActions>((set) => ({
	data: [],
	isLastPage: false,
	pageNo: 1,
	option: {},
	updateDataList: (data: any, pageNo: number, isLastPage: boolean, option: any) => {
		const { data: existingData } = useFinishedTaskDataStore.getState();
		let dataList: any[] = [];

		if (isLastPage) {
			const value = pageNo === 1 ? [] : existingData;
			set({
				data: [...value, ...data],
				pageNo: pageNo,
				isLastPage: isLastPage,
				option: option,
			});
			return;
		}

		if (pageNo === 1) {
			dataList = [...data];
		} else {
			dataList = [...existingData, ...data];
		}

		set({
			data: dataList,
			pageNo: pageNo,
			isLastPage: isLastPage,
			option: option,
		});
	},
	resetDataList: () => {
		set({
			data: [],
			isLastPage: false,
			pageNo: 1,
			option: {},
		});
	},
}));
